import store from '../'

const state = {
    menuOptions: {
        dashboard: {
            type: '',
            name: "Dashboard",
            section: "Account",
            url: '/users/home',
            item: {
                type: 'cpu',
                id: 1,
                contents: null,
            },
        },
        shoppingCart: {
            type: '',
            name: "My Builds",
            section: "Account",
            url: '/users/mybuild',
            item: {
                type: 'cpu',
                id: 1,
                contents: null,
            },
        },
        settings: {
            type: '',
            name: "Settings",
            section: "Account",
            url: '/users/settings',
            item: {
                type: 'cpu',
                id: 1,
                contents: null,
            },
        },
    },
    adminOptions: {
        accountDashboard: {
            type: '',
            name: "Dashboard",
            section: "Account",
            url: '/users/home',
            item: {
                type: 'cpu',
                id: 1,
                contents: null,
            },
        },
        adminDashboard: {
            type: '',
            name: "Admin Overview",
            section: "Administration",
            url: '/users/admin',
            item: {
                type: 'cpu',
                id: 1,
                contents: null,
            },
        },
        shoppingCart: {
            type: '',
            name: "My Builds",
            section: "Account",
            url: '/users/mybuild',
            item: {
                type: 'cpu',
                id: 1,
                contents: null,
            },
        },
        settings: {
            type: '',
            name: "Settings",
            section: "Account",
            url: '/users/settings',
            item: {
                type: 'cpu',
                id: 1,
                contents: null,
            },
        },
        addPart: {
            type: '',
            name: "All Parts",
            section: "Products",
            url: '/users/items-controller',
            item: {
                type: 'cpu',
                id: 1,
                contents: null,
            },
        },
        candidateParts: {
            type: '',
            name: "Onboard New Parts",
            section: "Products",
            url: '/users/candidates',
            item: {
                type: 'cpu',
                id: 1,
                contents: null,
            },
        },
        catalogHealth: {
            type: '',
            name: "Catalog Health",
            section: "Products",
            url: '/users/catalog-health',
            item: {
                type: 'cpu',
                id: 1,
                contents: null,
            },
        },
        contentManagement: {
            type: '',
            name: "Content Management",
            section: "Products",
            url: '/users/content',
            item: {
                type: 'cpu',
                id: 1,
                contents: null,
            },
        },
        buildCoverage: {
            type: '',
            name: "Build Coverage",
            section: "Products",
            url: '/users/build-coverage',
            item: {
                type: 'cpu',
                id: 1,
                contents: null,
            },
        },
        scheduledJobs: {
            type: '',
            name: "Scheduled Jobs",
            section: "Automation",
            url: '/users/jobs',
            item: {
                type: 'cpu',
                id: 1,
                contents: null,
            },
        },
        pipelines: {
            type: '',
            name: "Pipelines",
            section: "Automation",
            url: '/users/pipelines',
            item: {
                type: 'cpu',
                id: 1,
                contents: null,
            },
        },
        aiUsage: {
            type: '',
            name: "AI Usage",
            section: "AI",
            url: '/users/ai-usage',
            item: {
                type: 'cpu',
                id: 1,
                contents: null,
            },
        },
        aiPrompts: {
            type: '',
            name: "AI Prompts",
            section: "AI",
            url: '/users/ai-prompts',
            item: {
                type: 'cpu',
                id: 1,
                contents: null,
            },
        },
        affiliateSeo: {
            type: '',
            name: "SEO Advisor",
            section: "AI",
            url: '/users/affiliate-seo',
            item: {
                type: 'cpu',
                id: 1,
                contents: null,
            },
        },
        userManagement: {
            type: '',
            name: "User Management",
            section: "Administration",
            url: '/users/users-management',
            item: {
                type: 'cpu',
                id: 1,
                contents: null,
            },
        },
        audience: {
            type: '',
            name: "Audience",
            section: "Administration",
            url: '/users/audience',
            item: {
                type: 'cpu',
                id: 1,
                contents: null,
            },
        },
        subscribers: {
            type: '',
            name: "Subscribers",
            section: "Administration",
            url: '/users/subscribers',
            item: {
                type: 'cpu',
                id: 1,
                contents: null,
            },
        },
    }
};
const getters = {
    allAdminOptions: (state) => {
        if(store.getters.getUser && store.getters.getUser.is_admin == 1){
            return state.adminOptions
        }
        else {
            return state.menuOptions
        }
    },
};
const actions = {

};

const mutations = {

};

export default {
    state,
    getters,
    actions,
    mutations
}
